<template>
	<div class="pagesContent">
				<el-card>
					<el-form ref="Search" :model="Search" inline>
						<el-form-item label="公司编号">
							<el-input v-model="Search.CompanyId" placeholder="请输入公司编号" size="small" @change="searchSubmit"></el-input>
						</el-form-item>
						<el-form-item label="公司名称">
							<el-input v-model="Search.LikeCompanyName" placeholder="请输入公司名称" size="small" @change="searchSubmit">
							</el-input>
						</el-form-item>
						<el-form-item label="软件编号">
							<el-select v-model="Search.SoftwareId" placeholder="请选择" size="small" clearable @change="searchSubmit">
								<el-option v-for="item in softwareIdOptions" :key="item.Id"
									:label="item.Name" :value="item.Id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</el-card>
			<!-- 主体内容 -->
				<el-card class="card-box section" style="margin-top: 10px;">
					<div class="single-title">
					版本信息
					</div>
					<div class="single-model-other">
						<el-table size="mini" max-height="500" :data="VersionData" stripe border style="width: 100%">
							<el-table-column prop="CompanyId" label="公司编号" min-width="180" align="center"></el-table-column>
							<el-table-column prop="SoftwareId" label="软件编号" min-width="80" align="center"></el-table-column>
							<el-table-column prop="Software.Name" label="软件名称" min-width="80" align="center"></el-table-column>
							<el-table-column prop="Version" label="版本号" min-width="120" align="center"></el-table-column>
							<el-table-column prop="CreateTime" label="创建时间" min-width="100" align="center">
								<template slot-scope="scope">{{scope.row.CreateTime| dateYMDFormat}}</template>
							</el-table-column>
							<el-table-column prop="LastUpdateTime" label="最后修改时间" min-width="100" align="center">
								<template slot-scope="scope">{{scope.row.LastUpdateTime| dateYMDFormat}}</template>
							</el-table-column>
						</el-table>
						<el-pagination style="margin-top: 10px;" background :current-page.sync="table.PageIndex" :page-size.sync="table.PageSize"
							:page-sizes="[10, 20, 40, 50]" layout="total,sizes, prev, pager, next" :total="table.TotalCount"
							@size-change="handleSizeChange" @current-change="getCompanyVersion">
						</el-pagination>
					</div>
				</el-card>
				<el-card class="card-box section">
					<div class="single-title">
					版本升级记录
					</div>
					<div class="single-model-other">
						<el-table size="mini" max-height="500" :data="VersionRecord" stripe border style="width: 100%">
							<el-table-column prop="CompanyId" label="工厂编号" width="220" align="center"></el-table-column>
							<el-table-column prop="SoftwareId" label="软件编号" align="center"></el-table-column>
							<el-table-column prop="Software.Name" label="软件名称" width="140" align="center"></el-table-column>
							<el-table-column prop="Version" label="版本号" width="180" align="center"></el-table-column>
							<el-table-column prop="ToVersion" label="请求版本号" width="180" align="center"></el-table-column>
							<el-table-column prop="CreateTime" label="请求时间" align="center">
							<template slot-scope="scope">{{scope.row.CreateTime| dateYMDFormat}}</template>
							</el-table-column>
							<el-table-column prop="Status" label="请求状态" align="center">
							<!-- （ 0未知  1准备升级  2升级成功 3升级失败 4升级异常 ） -->
							<template slot-scope="scope">
								<span v-if="scope.row.Status == 1">准备升级</span>
								<span v-else-if="scope.row.Status == 2">升级成功</span>
								<span v-else-if="scope.row.Status == 3">升级失败</span>
								<span v-else-if="scope.row.Status == 4">升级异常</span>
								<span v-else>未知</span>
							</template>
							</el-table-column>
							<el-table-column prop="Text" label="请求文本" width="200" align="center"></el-table-column>
						</el-table>
						<el-pagination style="margin-top: 10px;" background :current-page.sync="tableUpgrade.PageIndex" :page-size="tableUpgrade.PageSize"
							:page-sizes="[10, 20, 40, 50]" layout="total,sizes, prev, pager, next" :total="tableUpgrade.TotalCount"
							@size-change="handleSizeChangeUpgrade" @current-change="getAllVersionRecord" >
						</el-pagination>
					</div>
				</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 软件编号
				softwareIdOptions:[],
				//顶部搜索
				Search: {
					CompanyId: '', //公司编号
					LikeCompanyName: '', // 公司名称
					SoftwareId:'',		//软件编号
				},
				table:{
					PageIndex:1,
					PageSize:10,
					TotalCount:null,
				},
				tableUpgrade:{
					PageIndex:1,
					pageSize:10,
					TotalCount:null,
				},
				//工厂版本信息表
				VersionData:[],
				//公司版本升级记录
				VersionRecord:[],
			}
		},
		mounted() {
			this.getCompanyVersion()
			this.getAllVersionRecord()
			this.getSoftwareInfoAll()
		},
		methods: {
			//版本信息
			getCompanyVersion(){
				this.$http.getAllPlantVersionPag(this.table.PageIndex,this.table.PageSize,this.Search).then(res=>{
					// console.log(res)
					if(res.status == 200){
						this.VersionData = res.data.Items
						this.table.TotalCount = res.data.TotalCount
					}
				})
			},
			// 版本升级记录
			getAllVersionRecord(){
				this.$http.getAllCompanyVersionLogPag(this.tableUpgrade.PageIndex,this.tableUpgrade.pageSize,this.Search).then(res=>{
					// console.log(res)
					if(res.status == 200) {
						this.VersionRecord = res.data.Items
						this.tableUpgrade.TotalCount = res.data.TotalCount
					}
				})
			},
			// 获取软件编号
			getSoftwareInfoAll(){
				this.$http.getSoftwareInfoAll().then(res=>{
					console.log(res)
					if(res.status == 200) {
						this.softwareIdOptions = res.data
					}
				})
			},
			handleSizeChange(val) {
				this.table.PageIndex = 1
				this.getCompanyVersion()
			},
			handleSizeChangeUpgrade(val){
				this.tableUpgrade.PageIndex = 1
				this.getAllVersionRecord()
			},
			/* 搜索 重置 */
			searchReset() {
				this.Search = this.$options.data.call(this).Search
			},
			/* 搜索 提交搜索 */
			searchSubmit() {
				this.table.PageIndex = 1
				this.tableUpgrade.PageIndex = 1
				this.getCompanyVersion()
				this.getAllVersionRecord()
			}
		}
	}
</script>

<style>
	.pagesContent {
		width: 100%;
		height: 100%;
	}

	.main-box {
		width: 100%;
		background-color: #FFFFFF;
	}


	/* 顶部地址 */
	.el-cascader-menu__wrap {
		height: 260px;
	}

	.el-cascader-menu {
		min-width: 260px;
	}

	.el-cascader-panel {
		font-size: 16px;
	}

	.aaa .el-radio__inner {
		top: -18px;
		left: -19px;
		border-radius: 0;
		border: 0;
		width: 170px;
		height: 34px;
		background-color: transparent;
		cursor: pointer;
		box-sizing: border-box;
		position: absolute;
	}
	.aaa .el-radio__input.is-checked .el-radio__inner {
		background: transparent;
	}

	.card-box {
		margin-bottom: 40px;
	}
	.single-model-other {
		padding: 10px 0;
	}
	.single-title {
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 20px;
		font-weight: 800;
		border-bottom: #CCCCCC 1px solid;
	}
	.single-model-company {
		padding: 20px 0 0 40px;
		margin-bottom: 40px;
	}

	.el-card__body{
		padding: 10px;
	}
</style>
